// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QaFVw","colBig":"styles_colBig__3hsSR","colSmall":"styles_colSmall__Evs_q"};